import { render } from "./Register.vue?vue&type=template&id=20a5d056"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
script.render = render

export default script